import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { setSelectedTable } from '../../redux-store'
import { useAppDispatch, useAppSelector } from '../../redux-store/hooks'
import { KitchenOngoingScreen } from '../admin-kitchen-screen'
import { BillingHistory } from '../billing-history'
import { ProductsViewer } from '../products-viewer'
import { TakeAwayOptionsScreen } from '../take-away'
import { FloorViewer } from './floor-viewer'

export const BillCounterHome = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatcher = useAppDispatch()
  const queryParams = new URLSearchParams(location.search)
  const tab = queryParams.get('tab') || 'ongoing' // Default value if not present
  const isTableView = tab === 'table'
  const isOngoingOrders = tab === 'ongoing'
  const isBillingHistory = tab === 'billing-history'
  const isTakeWayView = tab === 'new-take-away'
  const modifyBill = tab === 'modify-bill'

  const selectedTable = useAppSelector((state) => state.table.selectedTable)
  const selectedFloor = useAppSelector(
    (state) => state.preloadData.selectedFloor
  )
  const isTakeAwayTable = selectedTable?._id === '999'

  useEffect(() => {
    if (isTakeAwayTable && isTableView) {
      dispatcher(setSelectedTable(null))
    }
  }, [tab])

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      {/* Ongoing orders */}
      {isOngoingOrders && <KitchenOngoingScreen />}

      {/* Dine-In Screen */}
      {isTableView && (
        <Box flex="1">
          {selectedFloor && !selectedTable && (
            <FloorViewer selectedFloor={selectedFloor} />
          )}
          {selectedFloor && selectedTable && <ProductsViewer />}
        </Box>
      )}

      {/* Take-away Screen */}
      {isTakeWayView && (
        <Box flex="1">
          {!(selectedTable && selectedTable._id === '999') && (
            <TakeAwayOptionsScreen />
          )}
          {selectedTable && selectedTable._id === '999' && <ProductsViewer />}
        </Box>
      )}

      {/* Modify Bill Screen */}
      {modifyBill && (
        <Box flex="1">
          {selectedTable && <ProductsViewer />}
        </Box>
      )}

      {/* Billing History */}
      {isBillingHistory && (
        <>
          <BillingHistory />
        </>
      )}
    </Box>
  )
}
